import { Ban } from 'lucide-react'
import useBlock from 'hooks/useBlock'
import useActionGuard from 'hooks/useActionGuard'
import { Relationship, User } from '@wellesley/openapi'

import { redButton } from '../types'

type UseBlockUnblockActionsProps = {
  user: User
  isAuthor: boolean
  relationship: Relationship
}

const useBlockUnblockActions = ({
  user,
  isAuthor,
  relationship,
}: UseBlockUnblockActionsProps) => {
  const { isDisabled, guardedAction } = useActionGuard()
  const [isBlocked, block, unblock, renderBlockDialog] = useBlock({
    user,
    relationship,
  })

  const blockUnblockAction = {
    icon: <Ban size={20} color="var(--red-500)" />,
    name: isBlocked ? 'Unblock' : 'Block',
    handler: guardedAction(isBlocked ? unblock : block),
    className: redButton,
    isHidden: isAuthor,
    disabled: isDisabled,
  }

  return [blockUnblockAction, renderBlockDialog] as const
}

export default useBlockUnblockActions
